/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $slider = $el.find('.slider-help');
const $prev = $el.find('.slick-prev');
const $next = $el.find('.slick-next');
const $sliderDots = $el.find('.slider-dots');

$slider.slick({
    slidesToScroll: 3,
    slidesToShow: 3,
    infinite: false,
    arrows: true,
    dots: false,
    prevArrow: $prev,
    nextArrow: $next,
    appendDots: $sliderDots,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        },
   ]
});
